const state = () => ({
    _shownUpgrade: false,
    _shownDowngrade: false,
    _shownPaymentMethods: false,
    _backupPaymentMethods: false,
    _redirectPaymentMethods: true,
    _fromInboxPaymentMethods: null,
    _fromBroadcastPaymentMethods: null,
    _onlyAnnual: false,
});

const getters = {
    earlyUpgradeShown: (state) => state._shownUpgrade,
    earlyDowngradeShown: (state) => state._shownDowngrade,
    paymentMethodsShown: (state) => state._shownPaymentMethods,
    paymentMethodsBackup: (state) => state._backupPaymentMethods,
    paymentMethodsRedirect: (state) => state._redirectPaymentMethods,
    paymentMethodsFromInbox: (state) => state._fromInboxPaymentMethods,
    paymentMethodsFromBroadcast: (state) => state._fromBroadcastPaymentMethods,
    onlyAnnual: (state) => state._onlyAnnual,
};

const actions = {
    showEarlyUpgrade(onlyAnnual) {
        this._setEarlyUpgradeShown(onlyAnnual);
    },

    hideEarlyUpgrade() {
        this._setEarlyUpgradeHidden();
    },

    showEarlyDowngrade() {
        this._setEarlyDowngradeShown();
    },

    hideEarlyDowngrade() {
        this._setEarlyDowngradeHidden();
    },

    showPaymentMethods({ backup, redirect, inboxId, fromBroadcast }) {
        this._setPaymentMethodsShown({ backup, redirect, inboxId, fromBroadcast });
    },

    hidePaymentMethods() {
        this._setPaymentMethodsHidden();
    },

    // Private methods
    _setPaymentMethodsShown({ backup, redirect, inboxId, fromBroadcast }) {
        this._shownPaymentMethods = true;
        this._backupPaymentMethods = backup;
        this._redirectPaymentMethods = redirect;
        this._fromInboxPaymentMethods = inboxId;
        this._fromBroadcastPaymentMethods = fromBroadcast;
    },

    _setPaymentMethodsHidden() {
        this._shownPaymentMethods = false;

        setTimeout(() => {
            this._backupPaymentMethods = false;
            this._redirectPaymentMethods = true;
        }, 500);
    },

    _setEarlyUpgradeShown(onlyAnnual) {
        this._shownUpgrade = true;

        if (typeof onlyAnnual === 'boolean') {
            this._onlyAnnual = onlyAnnual;
        }
    },

    _setEarlyUpgradeHidden() {
        this._shownUpgrade = false;
        this._onlyAnnual = false;
    },

    _setEarlyDowngradeShown() {
        this._shownDowngrade = true;
    },

    _setEarlyDowngradeHidden() {
        this._shownDowngrade = false;
    },
};

export default {
    state,
    getters,
    actions,
};
